
import { openDialog } from '../base/dialog';

import { DisplayNamePrompt } from './components';

/**
 * Signals to open a dialog with the {@code DisplayNamePrompt} component.
 *
 * @param {?Function|Object} onPostSubmitOrProps - The function to invoke after a successful
 * submit of the dialog, or an object containing dialog props.
 * @returns {Object}
 */
export function openDisplayNamePrompt(onPostSubmitOrProps: ?Function | ?Object) {
    const dialogProps = typeof onPostSubmitOrProps === 'function'
        ? { onPostSubmit: onPostSubmitOrProps }
        : onPostSubmitOrProps || {};

    return openDialog(DisplayNamePrompt, dialogProps);
}
